import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Tabs,
  Tab,
  Box,
  TextField
} from '@mui/material';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
    </div>
  );
}

const WorkflowDiffModal = ({ open, onClose, onConfirm, diff, notes, setNotes }) => {
  const [tab, setTab] = React.useState(0);
  const stats = diff?.stats || {};
  const summary = diff?.summary || {};
  const patch = diff?.patch || [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Review Changes</DialogTitle>
      <DialogContent dividers>
        <Tabs value={tab} onChange={(e, v) => setTab(v)}>
          <Tab label="Summary" />
          <Tab label="Raw Patch" />
        </Tabs>
        <TabPanel value={tab} index={0}>
          <Typography variant="subtitle1" gutterBottom>
            Change Summary
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Adds: {stats.adds || 0}, Removes: {stats.removes || 0}, Replaces: {stats.replaces || 0}
          </Typography>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {summary.message || 'See the Raw Patch for exact operations.'}
          </Typography>
          <Box sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="Change Notes (optional)"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              multiline
              minRows={2}
            />
          </Box>
        </TabPanel>
        <TabPanel value={tab} index={1}>
          <Box component="pre" sx={{ bgcolor: '#f5f5f5', p: 2, borderRadius: 1, maxHeight: 400, overflow: 'auto' }}>
            {JSON.stringify(patch, null, 2)}
          </Box>
        </TabPanel>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={onConfirm}>
          Save as New Version
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkflowDiffModal;
